import { SelectProps } from "@cofano/cck/Select/Select";
import { TierUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const TierUnitSelect = ({ value, onChange }: Omit<SelectProps<TierUnit, false>, "fetchOptions">) => {
	return (
		<Select
			clearable={false}
			fetchOptions={Object.values(TierUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `TIER_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default TierUnitSelect;
